/**
 * Generación de identificadores.
 *
 * UUID v4 generado LOCALMENTE. La aplicación crea sus propios ids sin esperar
 * a ningún servidor: es la condición para que funcione sin red desde el primer
 * arranque (SPEC.md §3).
 *
 * No se usan claves naturales: no hay ninguna identidad determinista que
 * derivar aquí, y aleatorio es suficiente para una cuenta única.
 */

export type Id = string;

/**
 * `crypto.randomUUID` existe en Chrome Android, Chrome/Edge de escritorio y
 * Node ≥ 19, que es toda la matriz de destino. El respaldo cubre contextos
 * no seguros (http en LAN), donde `crypto.randomUUID` no está disponible
 * aunque `crypto.getRandomValues` sí.
 */
export function nuevoId(): Id {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

const PATRON_UUID =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function esId(valor: unknown): valor is Id {
  return typeof valor === 'string' && PATRON_UUID.test(valor);
}
